import DialogColor from "./dialogColor";

export default class DialogButton {
    constructor(text, btnClass, callback) {
        this.text = text;
        if (btnClass) {
            this.btnClass = 'btn-' + btnClass;
        }        
        this.callback = callback;
    }

    static new(text, btnClass, callback) {
        return new DialogButton(text, btnClass, callback);
    }

    static ok() {
        return new DialogButton('OK', null, null);
    }

    static cancel() {
        return new DialogButton('CANCEL', null, null);
    }    
}


// WEBPACK FOOTER //
// ./client/app/common/models/dialog/dialogButton.js